import React from "react";
import { Box, Container, Typography, Grid } from "@mui/material";

const MoreThanDietSection = () => {
  const features = [
    {
      icon: "🥦",
      title: "Simplicity Builds Healthy Habits:",
      description:
        "The Best Diet Plans Make Life Easier, Not Harder. We've designed Fitify to simplify meal planning, grocery tracking, and progress monitoring so you can focus on living healthier, not stressing about diets.",
      image: require("assets/images/about6.png"),
      imageAlt: "Fresh Green Vegetables and Fruits",
    },
    {
      icon: "🥗",
      title: "Nutrition Should Empower You:",
      description:
        "Fitify Turns Food Choices Into Real Progress. Our platform transforms your daily meals into clear insights, giving you the confidence to stay on track with personalized diet plans, reminders, and progress monitoring.",
      image: require("assets/images/about7.png"),
      imageAlt: "Healthy Kitchen Ingredients",
    },
    {
      icon: "🍎",
      title: "Wellness Should Be Sustainable:",
      description:
        "We Believe in Lasting Lifestyle Change. At Fitify, growth isn't about quick fixes—it's about balance. We help you create long-term, healthy nutrition habits that fuel your energy, fitness, and overall well-being.",
      image: require("assets/images/about8.png"),
      imageAlt: "Green Smoothies with Fresh Ingredients",
    },
  ];

  return (
    <Box sx={{ py: 8, position: "relative", zIndex: 2 }}>
      <Container maxWidth="xl">
        {/* Section Header */}
        <Box sx={{ textAlign: "center", mb: 8 }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: { xs: "2rem", md: "2.5rem", lg: "40px" },
              fontWeight: 600,
              fontFamily: "Outfit",
              color: "#5BF2FF",
              mb: 2,
              lineHeight: 1.2,
            }}
          >
            Fitify Is More Than Just A Diet Plan
          </Typography>

          <Typography
            sx={{
              fontSize: { xs: "1rem", md: "1.2rem" },
              fontWeight: 400,
              fontFamily: "Outfit",
              color: "#FFFFFF",
              lineHeight: 1.4,
              maxWidth: "900px",
              margin: "0 auto",
            }}
          >
            We've combined years of nutrition expertise, modern diet science,
            and intuitive design to create a platform that gives you complete
            visibility into your health and lifestyle goals.
          </Typography>
        </Box>

        {/* Main Content Card */}
        <Box
          sx={{
            backgroundColor: "#268088",
            borderRadius: "30px",
            padding: { xs: "32px 24px", md: "48px 40px", lg: "60px 50px" },
            maxWidth: "1200px",
            margin: "0 auto",
          }}
        >
          {/* Feature Blocks */}
          {features.map((feature, index) => (
            <Box
              key={index}
              sx={{
                mb: index < features.length - 1 ? { xs: 6, md: 8 } : 0,
              }}
            >
              <Grid container spacing={{ xs: 4, md: 6 }} alignItems="center">
                {/* Image */}
                <Grid item xs={12} md={6}>
                  <Box
                    sx={{
                      width: "100%",
                      height: { xs: "250px", md: "300px", lg: "350px" },
                      borderRadius: "20px",
                      overflow: "hidden",
                    }}
                  >
                    <Box
                      component="img"
                      src={feature.image}
                      alt={feature.imageAlt}
                      sx={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  </Box>
                </Grid>

                {/* Content */}
                <Grid item xs={12} md={6}>
                  <Box>
                    {/* Icon and Title */}
                    <Box
                      sx={{
                        fontSize: "2rem",
                        mr: 2,
                      }}
                    >
                      {feature.icon}
                    </Box>
                    <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                      <Typography
                        variant="h3"
                        sx={{
                          fontSize: {
                            xs: "1.3rem",
                            md: "1.5rem",
                            lg: "1.7rem",
                          },
                          fontWeight: 600,
                          fontFamily: "Outfit",
                          color: "#FFFFFF",
                          lineHeight: 1.3,
                        }}
                      >
                        {feature.title}
                      </Typography>
                    </Box>

                    {/* Description */}
                    <Typography
                      sx={{
                        fontSize: { xs: "0.95rem", md: "1rem", lg: "1.1rem" },
                        fontWeight: 400,
                        fontFamily: "Outfit",
                        color: "#FFFFFF",
                        lineHeight: 1.6,
                      }}
                    >
                      {feature.description}
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default MoreThanDietSection;
